import { render, staticRenderFns } from "./segment-table.vue?vue&type=template&id=21054bec&scoped=true"
import script from "./segment-table.vue?vue&type=script&lang=js"
export * from "./segment-table.vue?vue&type=script&lang=js"
import style0 from "./segment-table.vue?vue&type=style&index=0&id=21054bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21054bec",
  null
  
)

export default component.exports